// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    baseUrlFrontdoor: 'https://api.emmsit.asia.manulife.com/ext/dot-kh-frontdoor',
    //basesUrlBFF: 'https://api.emmsit.asia.manulife.com/ext/dot-kh-bff',
    basesUrlBFF: 'http://localhost:8080',
    baseUrlSIT: 'https://emm-sit-api.ap.manulife.com',
    baseUrlDEV: 'https://emm-dev-api.ap.manulife.com',
    baseUrlUAT: 'https://emm-uat-api.ap.manulife.com',
    baseUrlPRD: 'https://emm-prd-api.ap.manulife.com',
    market: "KH"
};
